
const ContactHero = () => {
  return (
    <section className="relative pt-32 pb-24 bg-primary-blue overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <h1 className="font-heading text-5xl lg:text-6xl text-white font-bold mb-6">
            Get in Touch
          </h1>
          <p className="text-lg text-blue-100 max-w-3xl mx-auto">
            We're here to help with your logistics needs. Reach out to our team for any inquiries or support.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
